module.exports = __webpack_public_path__ + "static/media/taxi.af9e5f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/taxi.png
// module id = 248
// module chunks = 0